<!--<ng-container *ngIf="!loadedRoute">-->
<!--  <h1>STANDALONE HELLO!</h1>-->
<!--  <button id="standalone-button" [routerLink]="[dfAppRoute, 'app']">GO TO APP</button>-->
<!--</ng-container>-->
<router-outlet></router-outlet>
